import React from 'react';

import { Switch } from '@gogame/components';
import { useUpdateReceiveNotification } from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

export const ReceiveNotificationSwitcher = ({ id, value = false }) => {
  const [updateReceiveNotification] = useUpdateReceiveNotification(id);
  const handleChange = async (_, newValue) => {
    await updateReceiveNotification({ value: newValue });
  };

  return (
    <Switch
      label={'Receive Notifications'}
      checked={value}
      onChange={handleChange}
    />
  );
};

export default ReceiveNotificationSwitcher;
